module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-608e0c48.png";